import axios from "axios";
import { baseUrlApiOtodis, xApiKeyOtodis } from "../../config/api/apiConfig";

class ServiceBureauService {
  private axios = axios.create({
    baseURL: baseUrlApiOtodis,
  });
  private axiosFile = axios.create({
    baseURL: baseUrlApiOtodis,
    responseType: "blob",
  });

  public setToken(token: string) {
    this.axios.defaults.headers.common["Authorization"] = "Bearer " + token;
  }

  public async GetServiceBureau(params?: any) {
    const queries = {
      ...(params?.service_bureau_code && {
        dealer_code: params.dealerCode,
      }),
    };
    try {
      return await this.axios.get<any>("/service-bureau", {
        headers: {
          "X-Api-Key": xApiKeyOtodis,
        },
        params: {
          ...queries,
        },
      });
    } catch (e: any) {
      throw new Error(e.response.data.message);
    }
  }

  public async updateServiceBureau(inputData?: any) {
    try {
      return await this.axios.put<any>("/service-bureau/update", inputData, {
        headers: {
          "X-Api-Key": xApiKeyOtodis,
        },
      });
    } catch (e: any) {
      throw new Error(e.response.data.message);
    }
  }
}

export const serviceBureauService = new ServiceBureauService();
